import { useEffect } from "react";
import type { AchievementDef } from "../engine/AchievementEngine";
import { AchievementGallery } from "./AchievementGallery";
import { useState } from "react";

interface PauseMenuProps {
  onResume: () => void;
  onSave: () => void;
  onLoad: () => void;
  onSettings: () => void;
  onReturnToTitle: () => void;
  achievements?: Record<string, AchievementDef>;
  achievementUnlocked?: Set<string>;
}

export function PauseMenu({
  onResume,
  onSave,
  onLoad,
  onSettings,
  onReturnToTitle,
  achievements = {},
  achievementUnlocked = new Set(),
}: PauseMenuProps) {
  const [showAchievements, setShowAchievements] = useState(false);
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        e.preventDefault();
        onResume();
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onResume]);

  const btnStyle: React.CSSProperties = {
    display: "block",
    width: "220px",
    padding: "0.75rem 1.5rem",
    fontSize: "1rem",
  };

  const hasAchievements = Object.keys(achievements).length > 0;

  const buttons: { label: string; action: () => void }[] = [
    { label: "Resume", action: onResume },
    { label: "Save", action: onSave },
    { label: "Load", action: onLoad },
    { label: "Settings", action: onSettings },
    ...(hasAchievements ? [{ label: "Achievements", action: () => setShowAchievements(true) }] : []),
    { label: "Return to Title", action: onReturnToTitle },
  ];

  if (showAchievements) {
    return (
      <AchievementGallery
        achievements={achievements}
        unlocked={achievementUnlocked}
        onClose={() => setShowAchievements(false)}
      />
    );
  }

  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: "rgba(0, 0, 0, 0.75)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.6rem",
        zIndex: 90,
      }}
    >
      <h2
        style={{
          fontSize: "1.3rem",
          fontWeight: 400,
          marginBottom: "1.5rem",
          opacity: 0.7,
        }}
      >
        Paused
      </h2>
      {buttons.map(({ label, action }) => (
        <button
          key={label}
          onClick={action}
          className="theme-button"
          style={btnStyle}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
